import React, { useContext } from "react";
import { Redirect, useLocation } from "react-router-dom";
import withAuthorization from "../../components/withAuthorization";
import isAdmin from "../../utils/isAdmin";
import isSafeAdmin from "../../utils/isSafeAdmin";
import { keys } from "lodash";
import AccountContext from "../../contexts/AccountContext";
import AuthUserContext from "../../components/AuthUserContext";
import AlbumsAdmin from "./AlbumsAdmin";
import AlbumsMember from "./AlbumsMember";
import AlbumsUser from "./AlbumsUser";

const AlbumsRouter = () => {
  const account = useContext(AccountContext);
  const user = useContext(AuthUserContext);
  const location = useLocation();
  
  // Determine viewer type
  const isAdminUser = isAdmin() || isSafeAdmin();
  const isMember = keys(account?.members || {}).includes(user.uid);
  const isRegularUser = !isAdminUser && !isMember;
  
  // Check if we're on the admin path
  const isAdminPath = location.pathname.includes('/admin/albums');
  const isRegularPath = location.pathname === '/albums';

  // Routing logic based on user type and path
  if (isAdminUser) {
    if (isAdminPath) {
      return <AlbumsAdmin />;
    } else if (isRegularPath) {
      return isMember ? <AlbumsMember /> : <AlbumsUser />;
    }
  } else if (isMember) {
    if (isAdminPath) {
      // Members not allowed on admin path
      return <Redirect to="/albums" />;
    } else if (isRegularPath) {
      return <AlbumsMember />;
    }
  } else if (isRegularUser) {
    if (isAdminPath) {
      // Regular users not allowed on admin path
      return <Redirect to="/albums" />;
    } else if (isRegularPath) {
      return <AlbumsUser />;
    }
  }

  // Fallback for any other cases
  return <Redirect to="/albums" />;
};

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(AlbumsRouter);